module.exports = {"returnTo":"Retourner à","authorNum":"No. d’autorisation","rmaDate":"Date RMA","reopen":"Rouvrir"}


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/rma/fr.json
// module id = OkWW
// module chunks = 1